import { Button, CircularProgress, darken } from "@mui/material";
import { t } from "i18next";
import { iresoftColors } from "../../../theme/ireColors";

interface SubmitButtonProps {
  isSubmitting: boolean;
}

const FormSubmitButton: React.FC<SubmitButtonProps> = ({ isSubmitting }) => (
  <Button
    type="submit"
    variant="contained"
    fullWidth
    disabled={isSubmitting}
    sx={{
      backgroundColor: iresoftColors.iresoftRed,
      color: iresoftColors.white,
      minHeight: 40,
      "&:hover": { backgroundColor: darken(iresoftColors.iresoftRed, 0.15) },
    }}
  >
    {isSubmitting ? (
      <CircularProgress size={22} color="inherit" />
    ) : (
      t("pages.currentlyReading.form.send")
    )}
  </Button>
);

export default FormSubmitButton;
